export default {
  loading: false,
  shipmentsByInterval: null,
};



// WEBPACK FOOTER //
// ./src/features/private/dashboard/dashboards/sc-dashboard-shipment-interval/store/states.js